// extracted by mini-css-extract-plugin
export default {"container":"Homepage_container__W0c+O","floatingButton":"Homepage_floatingButton__zAatA","blinkingHand":"Homepage_blinkingHand__Vs0nl","blink":"Homepage_blink__4OSL-"};